import { stateAbbreviations } from "./const/const";

export function getStateAbbreviation(stateName: string, divider?: string): string {
  return stateAbbreviations[stateName] ? `${divider || ","} ${stateAbbreviations[stateName]}` : "";
}
